import React from "react";
import { Modal } from "../../../../../shared/Modal/Modal";
import { useLogs } from "./hooks/useLogs";
import { Header } from "./shared/Header";
import styles from "./styles.module.scss";
import { Table } from "./shared/Table";

export function ModalDetailedLogs({
  isOpen,
  productId,
  clinics,
  inventoryType,
  onClose,
}) {
  const logs = useLogs({ productId, clinics, inventoryType });

  return (
    <Modal
      size="wide"
      shouldCloseOnOverlayClick={false}
      isOpen={isOpen}
      onClose={onClose}
      contentClassName={styles.root}
      header={
        <Header
          isPickerDisabled={logs.isLoading}
          period={logs.period}
          clinics={logs.clinics}
          download={logs.download}
          batch={logs.batch}
        />
      }
    >
      <Table data={logs} />
    </Modal>
  );
}
